import React from 'react';
import Button from "../components/ui/Button";
import Layout from "../layouts/Layout";
import { useNavigate } from 'react-router-dom';

export default function NotFound() {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="flex flex-col items-center justify-center h-full">
        <div className="text-center">
          <h1 className="text-6xl font-bold text-gray-800">404</h1>
          <p className="mt-4 text-lg text-gray-600">Page introuvable</p>
          <p className="mt-2 text-sm text-gray-500">
            Il semble que la page que vous cherchez n'existe pas.
          </p>
          <div className="mt-6">
            <Button
              onClick={() => navigate('/')}
            >
              <span>Retour à l'accueil</span>
            </Button>
          </div>
        </div>
      </div>
    </Layout>
  );
};
